  import {Injectable} from '@angular/core';
  import {Subject} from 'rxjs';
  import {PasswordExpiry} from './password-expiry.service';

  @Injectable()
  export class PasswordExpiryEmitter {
    passwordExpiryTypeEmitter = new Subject<PasswordExpiry | null>();
  }
